import { GLOBAL_CONFIG } from "@/global-config";
import { useUserToken } from "@/store/userStore";
import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router";

export function AuthInitializer({ children }: { children: React.ReactNode }) {
	const navigate = useNavigate();
	const location = useLocation();
	const { accessToken } = useUserToken();

	const isLoginPage = location.pathname.includes("/auth/login");

	useEffect(() => {
		if (accessToken) {
			// 有 token，如果在登录页则跳转到首页
			if (isLoginPage) {
				navigate(GLOBAL_CONFIG.defaultRoute, { replace: true });
			}
		} else {
			// 没有 token，如果不在登录页则跳转到登录页
			if (!isLoginPage) {
				navigate("/auth/login", { replace: true });
			}
		}
	}, [accessToken, isLoginPage, navigate]);

	return <>{children}</>;
}
